// export const API_URI= 'https://odidor-erp.herokuapp.com'
// export const API_URI = 'https://hamilton.cyclic.app'
// export const API_URI = 'https://surrey.cyclic.app'
export const API_URI = process.env.REACT_APP_API_URL;
// export const API_URI = "http://localhost:5000";
export const productsArr = [
  "Fauxwood",
  "Zebra_blinds",
  "Roller_shades",
  "Honeycomb",
];
export const invParents = [
  "Headrail",
  "Tube",
  "Clutch",
  "Lift_hardware",
  "Motor",
  "Fabric",
  "Bottom_rail",
  "Material",
];
export const AppVersion = "2.1.2";

export const menuItems = [
  {
    id: "pills-dashboards",
    title: "Dashboards",
    subtitle: "An Overview Management",
    tooltip: "Dashboards",
    icon: "bi bi-house-door-fill",
    permissions: ["admin"],
    links: [
      {
        to: "/",
        label: "Home",
        icon: "lni lni-home",
        permissions: ["admin", "production_manager", "production_associate"],
      },
    ],
  },
  {
    id: "pills-action",
    title: "Action/Task",
    subtitle: "Manage all actions",
    tooltip: "Actions",
    icon: "fadeIn animated bx bx-command",
    permissions: ["admin", "inhouse_installer"],
    links: [
      {
        to: "/action/add-action",
        label: "Create Action",
        icon: "fadeIn animated bx bx-file",
        permissions: ["admin", "production_manager", "production_associate"],
      },
      {
        to: "/action/list-action",
        label: "List Action",
        icon: "fadeIn animated bx bx-list-ul",
        permissions: ["admin", "production_manager", "production_associate"],
      },
    ],
  },
  {
    id: "pills-application",
    title: "Appointments",
    subtitle: "View all listed Schedules",
    tooltip: "Appointments",
    icon: "bx bx-calendar",
    permissions: ["admin", "inhouse_installer"],
    links: [
      {
        to: "/appointments",
        label: "All Appointments",
        icon: "bx bx-calendar-event",
        permissions: ["admin"],
      },
      {
        to: "/add-appointment",
        label: "Add Appointment",
        icon: "bx bx-calendar-plus",
        permissions: ["admin"],
      },
      {
        to: "/appointment-dashboard",
        label: "Dashboard",
        icon: "bx bx-calendar-plus",
        permissions: ["admin"],
      },
    ],
  },
  {
    id: "pills-widgets",
    title: "Order System",
    subtitle: "Order Management",
    tooltip: "Order",
    icon: "lni lni-cart",
    permissions: ["admin", "production_manager", "production_associate"],
    links: [
      {
        to: "/order/add-order",
        label: "Add Order",
        icon: "bi bi-box",
        permissions: ["admin"],
      },
      {
        to: "/order/list",
        label: "Order List",
        icon: "bi bi-bar-chart",
        permissions: ["admin"],
      },
      // {
      //   to: "/order/image-to-order",
      //   label: " Image to Order",
      //   customIcon: (
      //     <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="16" height="16" viewBox="0 0 48 48">
      //     <radialGradient id="oDvWy9qKGfkbPZViUk7TCa_eoxMN35Z6JKg_gr1" cx="-670.437" cy="617.13" r=".041" gradientTransform="matrix(128.602 652.9562 653.274 -128.6646 -316906.281 517189.719)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#1ba1e3"></stop><stop offset="0" stop-color="#1ba1e3"></stop><stop offset=".3" stop-color="#5489d6"></stop><stop offset=".545" stop-color="#9b72cb"></stop><stop offset=".825" stop-color="#d96570"></stop><stop offset="1" stop-color="#f49c46"></stop></radialGradient><path fill="url(#oDvWy9qKGfkbPZViUk7TCa_eoxMN35Z6JKg_gr1)" d="M22.882,31.557l-1.757,4.024c-0.675,1.547-2.816,1.547-3.491,0l-1.757-4.024	c-1.564-3.581-4.378-6.432-7.888-7.99l-4.836-2.147c-1.538-0.682-1.538-2.919,0-3.602l4.685-2.08	c3.601-1.598,6.465-4.554,8.002-8.258l1.78-4.288c0.66-1.591,2.859-1.591,3.52,0l1.78,4.288c1.537,3.703,4.402,6.659,8.002,8.258	l4.685,2.08c1.538,0.682,1.538,2.919,0,3.602l-4.836,2.147C27.26,25.126,24.446,27.976,22.882,31.557z"></path><radialGradient id="oDvWy9qKGfkbPZViUk7TCb_eoxMN35Z6JKg_gr2" cx="-670.437" cy="617.13" r=".041" gradientTransform="matrix(128.602 652.9562 653.274 -128.6646 -316906.281 517189.719)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#1ba1e3"></stop><stop offset="0" stop-color="#1ba1e3"></stop><stop offset=".3" stop-color="#5489d6"></stop><stop offset=".545" stop-color="#9b72cb"></stop><stop offset=".825" stop-color="#d96570"></stop><stop offset="1" stop-color="#f49c46"></stop></radialGradient><path fill="url(#oDvWy9qKGfkbPZViUk7TCb_eoxMN35Z6JKg_gr2)" d="M39.21,44.246l-0.494,1.132	c-0.362,0.829-1.51,0.829-1.871,0l-0.494-1.132c-0.881-2.019-2.467-3.627-4.447-4.506l-1.522-0.676	c-0.823-0.366-0.823-1.562,0-1.928l1.437-0.639c2.03-0.902,3.645-2.569,4.511-4.657l0.507-1.224c0.354-0.853,1.533-0.853,1.886,0	l0.507,1.224c0.866,2.088,2.481,3.755,4.511,4.657l1.437,0.639c0.823,0.366,0.823,1.562,0,1.928l-1.522,0.676	C41.677,40.619,40.091,42.227,39.21,44.246z"></path>
      //     </svg>
      //   ),
      //   permissions: ["admin", "production_manager"],
      // },
      {
        to: "/order/img-to-order-list",
        label: " Image to Order List",
        customIcon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="16"
            height="16"
            viewBox="0 0 48 48"
          >
            <radialGradient
              id="oDvWy9qKGfkbPZViUk7TCa_eoxMN35Z6JKg_gr1"
              cx="-670.437"
              cy="617.13"
              r=".041"
              gradientTransform="matrix(128.602 652.9562 653.274 -128.6646 -316906.281 517189.719)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stop-color="#1ba1e3"></stop>
              <stop offset="0" stop-color="#1ba1e3"></stop>
              <stop offset=".3" stop-color="#5489d6"></stop>
              <stop offset=".545" stop-color="#9b72cb"></stop>
              <stop offset=".825" stop-color="#d96570"></stop>
              <stop offset="1" stop-color="#f49c46"></stop>
            </radialGradient>
            <path
              fill="url(#oDvWy9qKGfkbPZViUk7TCa_eoxMN35Z6JKg_gr1)"
              d="M22.882,31.557l-1.757,4.024c-0.675,1.547-2.816,1.547-3.491,0l-1.757-4.024	c-1.564-3.581-4.378-6.432-7.888-7.99l-4.836-2.147c-1.538-0.682-1.538-2.919,0-3.602l4.685-2.08	c3.601-1.598,6.465-4.554,8.002-8.258l1.78-4.288c0.66-1.591,2.859-1.591,3.52,0l1.78,4.288c1.537,3.703,4.402,6.659,8.002,8.258	l4.685,2.08c1.538,0.682,1.538,2.919,0,3.602l-4.836,2.147C27.26,25.126,24.446,27.976,22.882,31.557z"
            ></path>
            <radialGradient
              id="oDvWy9qKGfkbPZViUk7TCb_eoxMN35Z6JKg_gr2"
              cx="-670.437"
              cy="617.13"
              r=".041"
              gradientTransform="matrix(128.602 652.9562 653.274 -128.6646 -316906.281 517189.719)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stop-color="#1ba1e3"></stop>
              <stop offset="0" stop-color="#1ba1e3"></stop>
              <stop offset=".3" stop-color="#5489d6"></stop>
              <stop offset=".545" stop-color="#9b72cb"></stop>
              <stop offset=".825" stop-color="#d96570"></stop>
              <stop offset="1" stop-color="#f49c46"></stop>
            </radialGradient>
            <path
              fill="url(#oDvWy9qKGfkbPZViUk7TCb_eoxMN35Z6JKg_gr2)"
              d="M39.21,44.246l-0.494,1.132	c-0.362,0.829-1.51,0.829-1.871,0l-0.494-1.132c-0.881-2.019-2.467-3.627-4.447-4.506l-1.522-0.676	c-0.823-0.366-0.823-1.562,0-1.928l1.437-0.639c2.03-0.902,3.645-2.569,4.511-4.657l0.507-1.224c0.354-0.853,1.533-0.853,1.886,0	l0.507,1.224c0.866,2.088,2.481,3.755,4.511,4.657l1.437,0.639c0.823,0.366,0.823,1.562,0,1.928l-1.522,0.676	C41.677,40.619,40.091,42.227,39.21,44.246z"
            ></path>
          </svg>
        ),
        permissions: ["admin", "production_manager"],
      },
    ],
  },
  {
    id: "dealer",
    title: "Dealer Management",
    tooltip: "Dealer",
    subtitle: "Dealer Panel",
    icon: "fadeIn animated bx bx-store",
    permissions: ["admin"],
    links: [
      {
        to: "/dealer/list-dealer",
        label: " All Dealer",
        icon: "bx bx-user-circle",
        permissions: ["admin"],
      },
      {
        to: "/dealer/add-dealer",
        label: " Add Dealer",
        icon: "bx bx-user-plus",
        permissions: ["admin"],
      },
    ],
  },
  {
    id: "pills-charts",
    title: "Analytics",
    subtitle: "Analytics, statistics & Reports Management",
    tooltip: "Charts",
    icon: "bi bi-graph-up",
    permissions: ["admin"],
    links: [
      {
        to: "/analytics/annual-sales",
        label: "Annual Sales",
        icon: "bi bi-bar-chart",
        permissions: ["admin"],
      },
      {
        to: "/analytics/productions",
        label: "Production Stat",
        icon: "bi bi-pie-chart",
        permissions: ["admin"],
      },
      {
        to: "/analytics/cost-inventory-utilization",
        label: "Cost Analytics",
        icon: "bi bi-pie-chart",
        permissions: ["admin"],
      },
      {
        to: "/analytics/invoice-estimate-analytics",
        label: "Invoice Analytics",
        icon: "bi bi-pie-chart",
        permissions: ["admin"],
      },    
    ],
  },
  {
    id: "pills-inventory",
    title: "Inventory",
    subtitle: "Inventory Management",
    tooltip: "Inventory",
    icon: "fadeIn animated bx bx-box",
    permissions: ["admin"],
    links: [
      {
        to: "/inventory/add-item",
        label: "Add Inventory Item",
        icon: "fadeIn animated bx bx-book-add",
        permissions: ["admin"],
      },
      {
        to: "/inventory/inventory-list",
        label: "List Inventory",
        icon: "fadeIn animated bx bx-file",
        permissions: ["admin"],
      },
      {
        to: "/inventory/inventory-catergory",
        label: "Manage Category",
        icon: "fadeIn animated bx bx-file",
        permissions: ["admin"],
      },
    ],
  },
  
  {
    id: "cost-management",
    title: "Cost Management",
    subtitle: "Manage Product Costs",
    tooltip: "Cost Management",
    icon: "bi bi-currency-dollar",
    permissions: ["admin"],
    links: [
      {
        to: "/cost-management/costing-profile",
        label: "Costing Profile",
        icon: "bi bi-file-earmark-text",
        permissions: ["admin"],
      },
      {
        to: "/cost-management/costing-summary",
        label: "Cost Summary",
        icon: "bi bi-bar-chart-line",
        permissions: ["admin"],
      },
    ],
  },
  {
    id: "products-management",
    title: "Product Management",
    subtitle: "Products & Attributes Management",
    tooltip: "Product Management",
    icon: "fadeIn animated bx bx-shopping-bag",
    permissions: ["admin"],
    links: [
      {
        to: "/product-management/add-product-attributes",
        label: "Add Product/Attribute",
        icon: "fadeIn animated bx bx-message-square-add",
        permissions: ["admin"],
      },
    ],
  },
  {
    id: "pills-apps",
    title: "Invoice",
    tooltip: "Invoice",
    subtitle: "Invoice & Estimate Management",
    icon: "lni lni-app-store",
    permissions: ["admin"],
    links: [
      {
        to: "/app/invoice-generator",
        label: "Invoice/Estimate Generator",
        icon: "fadeIn animated bx bx-file",
        permissions: ["admin"],
      },
      {
        to: "/app/list-invoices",
        label: "Invoice List",
        icon: "fadeIn animated bx bx-file",
        permissions: ["admin"],
      },
      {
        to: "/app/list-estimates",
        label: "Estimated List",
        icon: "fadeIn animated bx bx-file",
        permissions: ["admin"],
      },
        {
        to: "/invoice-templates",
        label: "Invoice Templates",
        icon: "fadeIn animated bx bx-file",
        permissions: ["admin"],
      },
    ],
  },
  {
    id: "user-management",
    title: "User Management",
    tooltip: "User Management",
    subtitle: "Manage Users",
    icon: "bi bi-person",
    permissions: ["admin"],
    links: [
      {
        to: "/user/add-user",
        label: "Add User",
        icon: "bi bi-person-plus",
        permissions: ["admin"],
      },
      {
        to: "/user/manage-user",
        label: "Manage Users",
        icon: "bi bi-person-lines-fill",
        permissions: ["admin"],
      },
    ],
  },
  {
    id: "app-settings",
    title: "App settings",
    tooltip: "App settings",
    subtitle: "Manage App settings",
    icon: "bi bi-gear",
    permissions: ["admin"],
    links: [
      {
        to: "/erp/settings/production-calculation",
        label: "Production Calculation",
        icon: "bi bi-calculator",
        permissions: ["admin"],
      },
      {
        to: "/erp/settings/all-production-calculations",
        label: "List All Calculation",
        icon: "bi bi-table",
        permissions: ["admin"],
      },
      {
        to: "/erp/settings/app-settings",
        label: "App Settings",
        icon: "bi bi-sliders",
        permissions: ["admin"],
      },
         {
        to: "/erp/settings/production-settings",
        label: "Production Settings",
        icon: "bi bi-sliders",
        permissions: ["admin"],
      },
    ],
  },
  {
    id: "matrix-config",
    title: "Matrix Configurations",
    subtitle: "Manage Matrix Configurations",
    tooltip: "Matrix Config",
    icon: "bi bi-calculator-fill",
    permissions: ["admin"],
    links: [
      {
        to: "/matrix/add-matrix",
        label: "Matrix Configurations",
        icon: "bi bi-person-plus",
        permissions: ["admin"],
      },
      {
        to: "/matrix/list-matrix",
        label: "List Matrix",
        icon: "bi bi-person-plus",
        permissions: ["admin"],
      },
    ],
  },
  {
    id: "schedule",
    title: "Schedule Management",
    subtitle: "Manage Order Schedule",
    tooltip: "Schedule",
    icon: "bi bi-calendar",
    permissions: ["admin", "production_manager", "production_associate"],
    links: [
      // {
      //   to: "/schedule/list-orders",
      //   label: "Dealer Orders for Scheduling",
      //   icon: "bi bi-person-plus",
      //   permissions: ["admin", "production_manager"],
      // },
      {
        to: "/schedule/view-all-orders",
        label: "All Orders for Scheduling",
        icon: "bi bi-person-plus",
        permissions: ["admin", "production_manager"],
      },
      // {
      //   to: "/schedule/view-schedules",
      //   label: "Schedules",
      //   icon: "bi bi-person-plus",
      //   permissions: ["admin", "production_manager", "production_associate"],
      // },
    ],
  },
  {
    id: "tutorial",
    title: "ERP Tutorial",
    subtitle: "Documentation and Tutorial Videos",
    tooltip: "Tutorials",
    icon: "bi bi-book-fill",
    permissions: ["admin"],
    links: [
      {
        to: "/erp/tutorial",
        label: "ERP Tutorials",
        icon: "bi bi-book-fill",
        permissions: ["admin", "production_manager", "production_associate"],
      },
    ],
  },
];
